import * as React from 'react'
import { useDispatch } from 'redux-react-hook'
import styled from 'styled-components'
import { Form } from 'react-final-form'
import { setPage } from '../../../actions/header.action'
import { signIn } from '../../../actions/auth.action'
import { Size } from '../../../constants/app.constant'
import * as HeaderConst from '../../../constants/header.constant'
import { when } from '../../../utils/mixin'
import { Button, ButtonGroup } from '../../atoms/button'
import {
  composeValidators,
  required,
  alphabeticAndNumeric,
} from '../../../utils/validator'
import TextFieldItem from '../../molecules/text-field/text-field'
// import { Header } from '../..//molecules/header'
const { useEffect } = React
const Login: React.SFC = () => {
  const dispatch = useDispatch()
  useEffect(
    () => {
      document.title = 'ログイン画面'
      dispatch(setPage(HeaderConst.HEADER_LOGIN))
    },
    [dispatch]
  )
  const onSubmit = async (formValues: any) => {
    dispatch(signIn(formValues))
  }

  return (
    <Wrapper>
      {/*<Header />*/}
      <TitleWrapper>
        <TitleText> eGym三国志 </TitleText>
        <TitleTextSecond> 運動履歴/お問い合わせ </TitleTextSecond>
      </TitleWrapper>
      <div>
        <FormWrapper>
          <Form
            onSubmit={onSubmit}
            validate={(values: any) => {
              const errors: any = {}
              errors.username = composeValidators(
                required('ユーザIDを入力してください')
              )(values.username)
              errors.password = composeValidators(
                required('パスワードを入力してください'),
                alphabeticAndNumeric
              )(values.password)
              return errors
            }}
            render={({ handleSubmit }) => (
              <form onSubmit={handleSubmit}>
                <FieldSet>
                  <TextFieldItem
                    name="username"
                    type="text"
                    label="ユーザID"
                    placeholder="moffuser1"
                    vertical
                    required={true}
                  />
                </FieldSet>
                <FieldSet>
                  <TextFieldItem
                    name="password"
                    type="password"
                    label="パスワード"
                    placeholder=""
                    vertical
                    required={true}
                  />
                </FieldSet>
                <ButtonGroup vertical css="width: 168px;margin: 30px auto;">
                  <Button primary>ログイン</Button>
                </ButtonGroup>
              </form>
            )}
          />
        </FormWrapper>
      </div>
    </Wrapper>
  )
}

export default Login

const Wrapper = styled.div`
  max-width: ${Size.BREAK_POINT.MOBILE}px;
  background: white;
  margin: 0 auto;
`
const TitleWrapper = styled.div`
  padding: 25px 75px 0;
`
const TitleText = styled.div`
  color: #505050;
  font-size: 20px;
  text-align: center;
`
const TitleTextSecond = styled.div`
  color: #505050;
  font-size: 16px;
  text-align: center;
`
const FormWrapper = styled.div`
  padding: 50px 30px 0;
`
const FieldSet = styled.div<{
  vertical?: boolean
}>`
  display: flex;
  justify-content: space-between;
  margin-bottom: 6px;
  padding: 0 30px;
  div {
    width: 100%;
  }
  ${when('vertical')(`
    flex-direction: column;
    align-items: start;
  `)};
`



// WEBPACK FOOTER //
// ./src/components/pages/login/login.tsx